import { render } from "./sku_wise_sale_details.vue?vue&type=template&id=1b50a5d3&scoped=true"
import script from "./sku_wise_sale_details.vue?vue&type=script&lang=js"
export * from "./sku_wise_sale_details.vue?vue&type=script&lang=js"

import "./sku_wise_sale_details.vue?vue&type=style&index=0&id=1b50a5d3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b50a5d3"]])

export default __exports__